import { BaseError } from './base';

export function APIVersionNotAvailableError(message, debug, code, kinveyRequestId) {
  this.name = 'APIVersionNotAvailableError';
  this.message = message || 'This API version is not available for your app.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
APIVersionNotAvailableError.prototype = Object.create(BaseError.prototype);
APIVersionNotAvailableError.prototype.constructor = APIVersionNotAvailableError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/apiVersionNotAvailable.js